//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import { get, post, put, deletes, patch } from '@/api/fetch.js';
import url from '@/api/serviceAPI.config.js';
export default {
  name: 'village',
  data: function data() {
    return {
      input: '',
      tableHeight: document.body.clientHeight - 255,
      pageNum: 0,
      pageSize: 10,
      listLoading: false,
      //loading
      renterList: [],
      filters: {
        searchWord: '',
        companyId: ''
      },
      dialogAddVisible: false,
      dialogManagerAddVisible: false,
      formLabelWidth: '110px',
      addForm: {
        functionName: '',
        describes: ''
      },
      addLoading: false,
      total: null,
      roleList: [],
      companyList: [],
      sels: [],
      currentPage: 0,
      firstPartData: [{
        name: '租户数',
        number: 120,
        unit: '个'
      }, {
        name: '用户数',
        number: 120,
        unit: '个'
      }, {
        name: '正常数',
        number: 120,
        unit: '个'
      }, {
        name: '禁用数',
        number: 120,
        unit: '个'
      }],
      rules: {
        functionName: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {},
  activated: function activated() {},
  deactivated: function deactivated() {},
  mounted: function mounted() {
    this.getUser();
  },
  methods: {
    //改变分页信息
    handleCurrentChange: function handleCurrentChange(val) {
      console.log(val);
      this.pageNum = val;
      this.getUser();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getUser();
    },
    //获取列表
    getUser: function getUser() {
      var _this = this;
      var para = Object.assign({
        pageNum: this.pageNum ? this.pageNum - 1 : this.pageNum,
        pageSize: this.pageSize
      });
      this.listLoading = true;
      get(url.fun.funSearch, para).then(function (res) {
        _this.total = res.data.totalNum;
        _this.roleList = res.data.datas;
        _this.listLoading = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    submitFrom: function submitFrom() {
      var _this2 = this;
      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this2.addLoading = true;
          if (_this2.addForm.id) {
            // 修改
            var obj = {
              id: _this2.addForm.id,
              functionName: _this2.addForm.functionName,
              describes: _this2.addForm.describes
            };
            patch(url.fun.updateFunctionSet, obj).then(function (res) {
              _this2.addLoading = true;
              _this2.$message({
                message: '提交成功',
                type: 'success',
                duration: 1500
              });
            }).catch(function (err) {
              console.log(err);
            }).finally(function () {
              _this2.dialogAddVisible = false;
              _this2.addForm = {
                functionName: '',
                describes: ''
              };
              _this2.getUser();
            });
          } else {
            put(url.fun.addFunctionSet, _this2.addForm).then(function (res) {
              _this2.addLoading = true;
              _this2.$message({
                message: '提交成功',
                type: 'success',
                duration: 1500
              });
            }).catch(function (err) {
              console.log(err);
            }).finally(function () {
              _this2.dialogAddVisible = false;
              _this2.addForm = {
                functionName: '',
                describes: ''
              };
              _this2.getUser();
            });
          }
        }
      });
    },
    //显示添加村组弹框
    addRoleDialogShow: function addRoleDialogShow() {
      this.dialogAddVisible = true;
    },
    //隐藏添加村组弹框
    addRoleDialogHide: function addRoleDialogHide() {
      this.dialogAddVisible = false;
      this.addForm = {
        task: {
          taskName: '',
          taskType: '',
          describes: '',
          startTime: '',
          endTime: ''
        },
        perArr: [],
        per: []
      };
    },
    //搜索
    seachRole: function seachRole() {
      this.pageNum = 0;
      this.pageSize = 10;
      this.currentPage = 0;
      this.getUser();
      this.handleCurrentChange(0);
    },
    //删除
    deleteFun: function deleteFun(row) {
      var _this3 = this;
      this.$confirm('确认删除选中记录吗？', '提示', {
        type: 'warning'
      }).then(function () {
        var id = [row.id];
        deletes(url.fun.delete + '?ids=' + id).then(function (res) {
          _this3.getUser();
        }).catch(function (error) {
          console.log(error);
        });
      });
    },
    /*functionCompany/deleteFunction*/
    // 显示编辑界面
    editRole: function editRole(row) {
      this.dialogAddVisible = true;
      this.addForm = Object.assign({}, row); //有现获取列表信息
    },
    addFun: function addFun() {
      this.dialogAddVisible = true;
    }
  }
};